
import React from 'react';

import Operation from './Operation.state';
import OperationListView from './OperationList.view';

const OperationList = ({
    operations,
    quantity,
    usek,
    usekAttributes
}) => {

    const handleRenderOperation = (operation) => {
        return (
            <Operation
                key={operation.id}
                operation={operation}
                quantity={quantity[operation.mj]}
                usek={usek}
                usekAttributes={usekAttributes}
            />
        );
    }

    return (
        <OperationListView
            operations={operations}
            onRenderOperation={handleRenderOperation}
        />
    );
}

export default OperationList;
